import Status from '@ingka/status';
import { tokens } from '../../../shared/styles/core/tokens';
import { formatProgressPercent, getProgressStatus, getProgressStatusColor } from '../../../shared/utils/progress.utils';

interface StatusIndicatorProps {
    status: number;
}

function getStatusText(status: number) {
    const progressStatus = getProgressStatus(status);
    if (progressStatus === 'Ongoing') return `Ongoing - ${formatProgressPercent(status)}`;
    return progressStatus;
}

export const StatusIndicator = ({ status }: StatusIndicatorProps) => (
    <div style={{ fontSize: tokens.font.size.md }}>
        <Status label={getStatusText(status)} statusColor={getProgressStatusColor(status)} />
    </div>
);
